import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types';
import { Repeat } from '@/entities/rrule/constants';

export const weekly = t.type({
  MO: t.boolean,
  TU: t.boolean,
  WE: t.boolean,
  TH: t.boolean,
  FR: t.boolean,
  SA: t.boolean,
  SU: t.boolean,
});

export const monthly = t.type({
  day: t.string,
  setpos: t.number,
});

const RepeatCodec = t.keyof({
  [Repeat.NoRepeat]: null,
  [Repeat.Custom]: null,
  [Repeat.Daily]: null,
  [Repeat.Weekly]: null,
  [Repeat.Weekday]: null,
  [Repeat.Monthly]: null,
  [Repeat.Yearly]: null,
  [Repeat.Day]: null,
  [Repeat.WeekendDay]: null,
});

const customRuleCodec = t.partial({
  frequency: t.union([RepeatCodec, t.null]),
  monthly,
  weekly,
});

const customSendableRuleCodec = t.partial({
  frequency: t.union([t.string, t.null]),
  monthly,
  weekly: t.array(t.string),
});

const editableBaseRuleCodec = t.type({
  interval: t.union([t.number, t.null]),
  start: t.union([DateFromUnixTime, t.null]),
  repeat: t.string,
});

const sendableRuleBaseCodec = t.type({
  interval: t.union([t.number, t.null]),
  start: t.union([t.number, t.null]),
  repeat: t.string,
});

export const ruleCodec = t.intersection([editableBaseRuleCodec, customRuleCodec]);
export const sendableRuleCodec = t.intersection([sendableRuleBaseCodec, customSendableRuleCodec]);
